var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-modal",style:(_vm.userStyle),on:{"touchstart":_vm.touchstartFn,"touchmove":_vm.touchmoveFn,"touchend":_vm.touchendFn}},[_c('div',{staticClass:"active-desc",on:{"click":_vm.toHomeMy}},[_vm._v("面试")])])}
var staticRenderFns = []

export { render, staticRenderFns }